module.exports = __webpack_public_path__ + "static/media/candle-holder.3f8cece2.svg";